// 報價單封存的規則(業主 2026-10-16)。
//
// **只有已結案、已取消、草稿封存得了**,封存區也照這三類分頁。已寄出的還在跟客戶談,
// 要封存請先改狀態。真正的把關在後端(送了也是 409),這裡只是讓按鈕在按之前就說得出原因。

import type { QuoteStatus } from "../../api/types";

export type ArchiveTab = "CLOSED" | "CANCELLED" | "DRAFT";

export const ARCHIVE_TABS: { key: ArchiveTab; label: string }[] = [
  { key: "CLOSED", label: "已結案" },
  { key: "CANCELLED", label: "已取消" },
  { key: "DRAFT", label: "草稿" },
];

export function canArchive(status: QuoteStatus): boolean {
  return status === "CLOSED" || status === "CANCELLED" || status === "DRAFT";
}

export const ARCHIVE_REFUSED = "已寄出的報價單不能封存;只有已結案、已取消、草稿可以封存";

/** 封存之後跳去的地方:封存區裡這張單那一類的分頁。 */
export function archiveTabUrl(status: QuoteStatus): string {
  const tab = canArchive(status) ? status : "CLOSED";
  return `/quotes/archive?status=${tab}`;
}
